<template>
  <div :class="[$style.overlay, { [$style.fixed]: fixed }]">
    <div :class="$style.spinnerContainer">
      <moon-loader />
    </div>
  </div>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MoonLoader from 'vue-spinner/src/MoonLoader';

// TODO (Chernodub V.): this spinner is used across different apps, so we have to move it in the global scope
/**
 * Component to display overlay with spinner.
 *
 * It uses absolute positioning, so it will overlap the first parent with
 * `position: related`
 */
@Component({
  components: { MoonLoader },
  props:      {
    fixed: {
      type:    Boolean,
      default: false,
    },
  },
})
export default class LoadingSpinner extends Vue {}
</script>

<style lang="scss" module>
.overlay {
  z-index: 9999;
  position: absolute;
  left: 0;
  top: 0;
  background-color: white;
  width: 100%;
  height: 100%;

  &.fixed {
    position: fixed;
  }
}

.spinnerContainer {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/apps/configurator/components/LoadingSpinner.vue